const sendEvent = function(action, label) {
	window.dataLayer = window.dataLayer || []
	window.dataLayer.push({
		event: 'standard',
		eventCategory: 'petite-reine-site-visuel',
		eventAction: action,
		eventLabel: label
	})
}

export default sendEvent
